var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9197 8.18018H11.6897H6.07975C5.11975 8.18018 4.63975 9.34018 5.31975 10.0202L10.4997 15.2002C11.3297 16.0302 12.6797 16.0302 13.5097 15.2002L15.4797 13.2302L18.6897 10.0202C19.3597 9.34018 18.8797 8.18018 17.9197 8.18018Z",
    fill: "#011233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.c64c515c95232516732a654ebdc04ea2.svg";
export { ForwardRef as ReactComponent };